"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * Creates an action to set the audio input device for a broadcast.
 * This is different from setAudioInputDevice as it is not tied to a specific user or vendor
 * All it does is just store the device in the redux state for later use
 *
 * @param {string|Object} device - The audio input device ID or device object
 * @returns {Object} Redux action with the device as payload
 */
function setGenericAudioInputDevice(device) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_AUDIO_DEVICE, device);
}
var _default = exports["default"] = setGenericAudioInputDevice;